export function jsonToBlob(obj: object): Blob {
  return new Blob([JSON.stringify(obj)], { type: 'application/json' });
}